import script from "./ContactUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUpdate.vue?vue&type=script&setup=true&lang=js"

import "./ContactUpdate.vue?vue&type=style&index=0&id=dab87784&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dab87784"]])

export default __exports__